<div class="flex-column"
     style="height: 100%;">

  <app-region-menu [selectedCity]="selectedCity"
                   (changeCity)="onChangeCity($event)"></app-region-menu>

  <app-movie-list [city2]="selectedCity"></app-movie-list>
</div>
